<template>
    <app-layout title="Profile">
        <page-header>
            <template #title>
                <h1>Profile</h1>
            </template>
        </page-header>

        <div class="xl:flex px-8 gap-x-6 gap-y-6 justify-between">
            <div class="flex flex-1" v-if="$page.props.jetstream.canUpdateProfileInformation">
                <update-profile-information-form :user="$page.props.user" />
            </div>

            <div class="flex flex-1" v-if="$page.props.jetstream.canUpdatePassword">
                <update-password-form class="" />
            </div>

            <!-- <div v-if="isAdmin && $page.props.jetstream.canManageTwoFactorAuthentication">
                <two-factor-authentication-form class="mt-10 sm:mt-0" />
                <two-factor-authentication-form class="" />

                <jet-section-border />
            </div>

            <logout-other-browser-sessions-form v-if="isAdmin" :sessions="sessions" class="mt-10 sm:mt-0" />

            <template v-if="isAdmin && $page.props.jetstream.hasAccountDeletionFeatures">
                <jet-section-border />

                <delete-user-form class="mt-10 sm:mt-0" />
            </template> -->
        </div>
    </app-layout>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout.vue'
    import DeleteUserForm from '@/Pages/Profile/Partials/DeleteUserForm.vue'
    import JetSectionBorder from '@/Jetstream/SectionBorder.vue'
    import LogoutOtherBrowserSessionsForm from '@/Pages/Profile/Partials/LogoutOtherBrowserSessionsForm.vue'
    import TwoFactorAuthenticationForm from '@/Pages/Profile/Partials/TwoFactorAuthenticationForm.vue'
    import UpdatePasswordForm from '@/Pages/Profile/Partials/UpdatePasswordForm.vue'
    import UpdateProfileInformationForm from '@/Pages/Profile/Partials/UpdateProfileInformationForm.vue'
    import PageHeader from '@/Layouts/partials/PageHeader.vue'

    export default {
        props: ['sessions'],

        components: {
            AppLayout,
            DeleteUserForm,
            JetSectionBorder,
            LogoutOtherBrowserSessionsForm,
            TwoFactorAuthenticationForm,
            UpdatePasswordForm,
            UpdateProfileInformationForm,
            PageHeader,
        },
    }
</script>
